import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Title } from "../atoms/Title";
import { SubTitle } from "../atoms/SubTitle";
import { PageExplainText } from "../atoms/PageExplainText";

// CSS
const useStyles = makeStyles((theme) => ({ }));

// All the incoming values
interface IProps {
    title: string;
    subTitle?: string;
    explainText: string;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const PageHeader = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (<>
        <Title title={props.title} />
        {props.subTitle && <SubTitle subTitle={props.subTitle} />}
        <PageExplainText>{props.explainText}</PageExplainText>        
    </>)
}